import React from 'react';


import {withCssModule} from '@pb/kit-util-with-css-module';

import styles from '../../dialog.module.styl';

import type {ComponentPropsWithoutRef} from 'react';

const classNames = withCssModule(styles);

type NativeProps = ComponentPropsWithoutRef<'div'>;

export type DialogFooterProps = NativeProps;

/**
 * Action bar rendered at the bottom of a `<Dialog>` or `<AlertDialog>` panel.
 *
 * Applies consistent padding and a horizontal group layout for action buttons
 * (e.g. Confirm / Cancel). Pass `<Button>` elements as `children`. All native
 * `<div>` props are forwarded; `className` is merged with the internal layout classes.
 */
export const DialogFooter = ({
    className,
    ...restProps
}: DialogFooterProps) => {
    return (
        <div
            {...restProps}
            className={classNames('dialog-footer group pd-l group_m', className)}>
            {restProps.children}
        </div>
    );
};

DialogFooter.displayName = 'DialogFooter';
